export default __webpack_public_path__ + "static/media/tm.613323bc.svg";